<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <v-row class="text-left search-bar">
      <v-col class="pt-4 pl-0 col-9 col-md-7 col-lg-5">
        <v-tabs class="tabsLeft" color="#ED6D00" align-with-title>
          <v-tabs-slider color="#ED6D00"></v-tabs-slider>
          <v-tab>{{$t('__device')}}</v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <div class="text-left" style="padding-top:0%; padding-bottom: 80px; overflow-y:scroll" :style="viewStyle">
      
      <!-- Device Section -->
      <div id="box" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{ $t('__device') }}</h4>
        </v-row>
        
        <v-form ref="form" v-model="valid" lazy-validation :disabled="isReadOnly">
          <v-row class="mx-2">
            <!-- Left Column -->
            <v-col class="pa-0 col-12 col-md-6">
              
              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__serialNumber')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.serialNumber" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__type')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-select class="text_field" dense background-color="white" outlined v-model="datasets.type" :items="typeList" item-text="text" item-value="value" hide-details></v-select>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__brand')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.brand" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style">{{$t('__version')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.version" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__customer')}}</div>
                </v-col>
                <v-col class="col-8 col-md-7">
                  <v-text-field class="text_field clickable-field" dense background-color="white" outlined :value="datasets.customer" readonly :placeholder="$t('__select')" hide-details :clearable="!isReadOnly" @click="isReadOnly ? null : openCustomerDialog()" @click:clear="datasets.customer = ''" style="cursor: pointer;"></v-text-field>
                </v-col>
                <v-col class="col-1 col-md-1 pa-0 d-flex align-center">
                  <v-btn v-if="!isReadOnly" icon color="#00BCD4" class="mt-n1 bubble-plus-btn" @click="addCustomer">
                    <v-icon size="40">mdi-plus-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__contactPerson')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.contactPerson" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__contactPhone')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.phoneNumber" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__contactEmail')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.emailAddress" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__clientAssetNumber')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.clientAssetNumber" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__deviceLocation')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.deviceLocation" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__deviceDescription')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.deviceDescription" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style">{{$t('__sales')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field clickable-field" dense background-color="white" outlined :value="salesDisplay" readonly hide-details @click="isReadOnly ? null : openEmployeeDialog('sales')" style="cursor: pointer;"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style">{{$t('__group')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-select class="text_field" dense background-color="white" outlined v-model="datasets.groupName" :items="groupList" :clearable="!isReadOnly" hide-details></v-select>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style">{{$t('__projectID')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.projectId" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style">{{$t('__project')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.projectName" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__itemName')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.itemName" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__itemCode')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.itemCode" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__sapInvoiceNumber')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.sapInvoiceNumber" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4 d-flex align-center justify-end">
                  <div class="pt14 label-style"><span class="start">*</span>{{$t('__deviceCurrency')}}</div>
                </v-col>
                <v-col class="col-9 col-md-3">
                  <v-select class="text_field" dense background-color="white" outlined v-model="datasets.deviceCurrency" :items="currencyList" hide-details></v-select>
                </v-col>
                
                <v-col class="px-0 col-3 col-md-2 d-flex align-center justify-end">
                  <div class="pt14 label-style"><span class="start">*</span>{{$t('__deviceAmount')}}</div>
                </v-col>
                <v-col class="col-9 col-md-3">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.deviceAmount" type="number" step="0.01" hide-details @blur="formatAmount"></v-text-field>
                </v-col>
              </v-row>

            </v-col>

            <!-- Right Column -->
            <v-col class="pa-0 col-12 col-md-6">
              
              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__caseId')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined :value="datasets.caseId || datasets.id" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__startDate')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                   <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="datasets.startDateString" dense outlined background-color="white" readonly v-bind="attrs" v-on="on" hide-details class="text_field"></v-text-field>
                    </template>
                    <v-date-picker v-model="datasets.startDate" @input="handleDateSelect('start', $event)" no-title></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-row class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style"><span class="start">*</span>{{$t('__endDate')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                   <v-menu v-model="endDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="datasets.endDateString" dense outlined background-color="white" readonly v-bind="attrs" v-on="on" hide-details class="text_field"></v-text-field>
                    </template>
                    <v-date-picker v-model="datasets.endDate" @input="handleDateSelect('end', $event)" no-title></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-row v-if="addNewData == 1" class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style">{{$t('__status')}}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.status" hide-details></v-text-field>
                </v-col>
              </v-row>

              <!-- Audit Info Section (Fixed Display) -->
              <v-row v-if="addNewData == 1" class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style">{{ $t('__reporter') }}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.creatorName" hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="addNewData == 1" class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style">{{ $t('__createTime') }}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.createTimeString" hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="addNewData == 1" class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style">{{ $t('__editor') }}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.editorName" hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="addNewData == 1" class="ma-0 form-row">
                <v-col class="px-0 col-3 col-md-4">
                  <div class="text-right pt-2 pt14 label-style">{{ $t('__updateTime') }}</div>
                </v-col>
                <v-col class="col-9 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.updateTimeString" hide-details></v-text-field>
                </v-col>
              </v-row>

            </v-col>
          </v-row>
        </v-form>
      </div>

      <S3FileManager 
        folder="Device" 
        :sub-path="datasets.caseId || (datasets.id ? String(datasets.id) : 'empty-create')" 
        :section-title="$t('__contractDocument')" 
        :read-only="isReadOnly || (!datasets.id && !datasets.caseId)" 
        @files-updated="updateAttachmentFiles"
      />

      <!-- Maintenance Section -->
      <div id="box" class="pa-5 mt-5">
        <v-row class="pb-5 align-center" style="padding: 0px 2.5% 20px 2.5%">
          <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{ $t('__maintenanceTab') }}</h4>
          <v-spacer></v-spacer>
          <v-btn v-if="!isReadOnly && maintenanceRecords.length < 1" dark class="ma-0 py-0" style="background-color: #ED6D00; border-radius: 8px" depressed @click="showAddMaintenanceDialog = true">
            {{$t('__bindMaintenanceContract')}}
          </v-btn>
        </v-row>

        <div id="listTable" class="ma-0">
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr class="grey lighten-4">
                  <th class="text-center font-weight-bold">{{$t('__serialNumber')}}</th>
                  <th class="text-center font-weight-bold" style="width: 15%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in maintenanceRecords" :key="idx" :class="idx % 2 === 1 ? 'row-even' : ''">
                  <td class="text-center py-2" style="min-width:70px">{{item.serialNumber}}</td>
                  <td class="text-center" style="min-width:120px">
                    <v-avatar color="#979491" size="30" tile @click="goToMaintenance(item.serialNumber)"
                      class="mr-1 action-btn-delete" style="cursor: pointer;">
                      <v-icon color="#FFFFFF" size="20">mdi-file-document-outline</v-icon>
                    </v-avatar>
                    <v-avatar v-if="!isReadOnly" color="#4C4948" size="30" tile @click="$refs.DeleteConfirm.open(1, '', '', true, idx)"
                      class="action-btn-delete" style="cursor: pointer;">
                      <v-icon color="#FFFFFF" size="20">mdi-delete</v-icon>
                    </v-avatar>
                  </td>
                </tr>
                <tr v-if="maintenanceRecords.length === 0">
                  <td colspan="2" class="text-center grey--text py-10 font-italic">{{ $t('__noMaintenanceRecordsAdded') }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>

    </div>
    
    <v-footer id="footer" class="fixed-footer">
      <div class="text-center mx-auto footer">
        <v-btn class="btn" large color="#979491" style="color: #FFF; box-shadow:none" @click="redirectPath('/WarrantyAndMaintenance')">{{$t('__cancel')}}</v-btn>
        <v-btn v-if="!isReadOnly" class="btn" large color="#ED6D00" style="color: #FFF; box-shadow:none" @click="saveDataset()">{{$t('__confirm')}}</v-btn>
      </div>
    </v-footer>

    <ShowMsg ref="ShowMsg" :onSave="onSaveSuccess" />
    <DeleteConfirm ref="DeleteConfirm" :onSave="onDeleteConfirm" />

    <!-- New Customer Dialog -->
    <v-dialog v-model="showNewCustomerDialog" min-width="500px" max-width="700px" persistent>
      <v-card class="dialog-padding">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <span class="dialog-title">{{$t('__newCustomer')}}</span>
          <v-btn icon @click="showNewCustomerDialog = false">
            <v-icon size="30" color="#9E9E9E">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-form ref="newCustomerForm" lazy-validation>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__customerName')}}</div>
              <v-text-field v-model="newCustomerData.name" outlined dense hide-details placeholder="" :rules="[v => !!v || 'Name is required']"></v-text-field>
            </div>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;">{{$t('__abbreviation')}}</div>
              <v-text-field v-model="newCustomerData.abbreviation" outlined dense hide-details placeholder=""></v-text-field>
            </div>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;">{{$t('__contactPerson')}}</div>
              <v-text-field v-model="newCustomerData.contactPerson" outlined dense hide-details placeholder=""></v-text-field>
            </div>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;">{{$t('__phone')}}</div>
              <v-text-field v-model="newCustomerData.phoneNumber" outlined dense hide-details placeholder=""></v-text-field>
            </div>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;">{{$t('__address')}}</div>
              <v-text-field v-model="newCustomerData.address" outlined dense hide-details placeholder=""></v-text-field>
            </div>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;">{{$t('__email')}}</div>
              <v-text-field v-model="newCustomerData.emailAddress" outlined dense hide-details placeholder=""></v-text-field>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="justify-center pb-8">
          <v-btn class="colorBtn" outlined color="#FFF" @click="showNewCustomerDialog = false">{{$t('__cancel')}}</v-btn>
          <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="saveNewCustomer">{{$t('__confirm')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Employee Selection Dialog -->
    <v-dialog v-model="showEmployeeDialog" min-width="500px" max-width="700px" persistent>
      <v-card class="dialog-padding">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <span class="dialog-title">{{ $t('__sales') }}</span>
          <v-btn icon @click="showEmployeeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-4 pb-0 keyword-bar">
          <!-- Search -->
          <v-text-field outlined :placeholder="$t('__keywordSearch')" class="mt-1 mb-2 keyword text_field"
          dense v-model="employeeSearchKeyword" background-color="white">
            <template v-slot:append>
              <v-icon color="white" style="background:#ED6D00">
              icon-form_search
              </v-icon>
            </template>
          </v-text-field>

          <!-- Employee List -->
            <div id="listTable" style="margin:0; padding:0">
              <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 40px;" class="text-center"></th>
                    <th class="text-left" style="width: 140px;">{{$t('__staffName')}}</th>
                    <th class="text-left" style="width: 120px;">{{$t('__empId')}}</th>
                    <th class="text-left" style="width: 90px;">{{$t('__title')}}</th>
                    <th class="text-left" style="width: 100px;">{{$t('__account')}}</th>
                    <th class="text-left" style="width: 110px;">{{$t('__phone')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="emp in filteredEmployeeList" :key="emp.employeeId || emp.id" @click="toggleEmployee(emp.name)" style="cursor: pointer;" :class="{ 'emp-selected-row': isEmployeeSelected(emp.name) }">
                    <td class="text-center">
                      <v-icon v-if="isEmployeeSelected(emp.name)" color="#ED6D00" size="20">mdi-checkbox-marked</v-icon>
                      <v-icon v-else color="#999" size="20">mdi-checkbox-blank-outline</v-icon>
                    </td>
                    <td class="text-left" style="min-width:140px">{{ emp.name }}</td>
                    <td class="text-left" style="min-width:120px">{{ emp.employeeId }}</td>
                    <td class="text-left" style="min-width:90px">{{ emp.title }}</td>
                    <td class="text-left" style="min-width:90px">{{ emp.account }}</td>
                    <td class="text-left" style="min-width:90px">{{ emp.phone }}</td>
                  </tr>
                  <tr v-if="filteredEmployeeList.length === 0">
                    <td colspan="6" class="text-center grey--text py-4">{{ $t('__noEmployeesFound') }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <!-- Selected summary -->
          <div class="mt-3 text-body-2 d-flex flex-wrap align-center" style="color: #666; gap: 8px;">
            <span>{{ $t('__selected') }}:</span>
            <template v-if="employeeDialogSelected.length > 0">
              <v-chip v-for="(name, idx) in employeeDialogSelected" :key="idx"
                class="ma-1" small close outlined color="#ED6D00"
                @click:close="removeSelectedEmployee(name)">
                {{ name }}
              </v-chip>
            </template>
            <span v-else><strong>{{ $t('__none') }}</strong></span>
          </div>
        </v-card-text>

        <v-card-actions class="justify-center pb-4 px-4 mt-2">
          <v-btn class="colorBtn" outlined color="#FFF" @click="showEmployeeDialog = false">{{$t('__cancel')}}</v-btn>
          <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="confirmEmployeeSelection">{{$t('__confirm')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Maintenance Dialog -->
    <v-dialog v-model="showAddMaintenanceDialog" max-width="500px" persistent>
      <v-card class="dialog-padding">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <span class="dialog-title">{{$t('__bindMaintenanceContract')}}</span>
          <v-btn icon @click="showAddMaintenanceDialog = false">
            <v-icon size="30" color="#9E9E9E">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-form lazy-validation>
            <div class="mb-1 autocompleteSelect">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__serialNumber')}}</div>
              <v-autocomplete class="text_field autocomplete" 
              :items="maintenanceList" :item-text="item => `(${item.serialNumber || ''}) ${item.customer || ''}`" item-value="serialNumber" v-model="newMaintenanceSerialNumber" ></v-autocomplete>
              <!-- <v-text-field v-model="newMaintenanceSerialNumber" outlined dense hide-details placeholder="" :rules="[v => !!v || 'Required']"></v-text-field> -->
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="justify-center pb-4 px-4 mt-2">
          <v-btn class="colorBtn" outlined color="#FFF" @click="showAddMaintenanceDialog = false">{{$t('__cancel')}}</v-btn>
          <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="addMaintenance">{{$t('__confirm')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ShowMsg ref="ShowMsg" :onSave="onSaveSuccess" />
    <CustomerSelectDialog ref="customerSelectDialog" @confirm="onCustomerSelected" />
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ShowMsg from '@/dialogs/ShowMsg'
import DeleteConfirm from '@/dialogs/DeleteConfirm'
import CustomerSelectDialog from '@/dialogs/CustomerSelectDialog'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import S3FileManager from '@/components/S3FileManager'
import { getEmployeeInfo } from '@/utils/auth'

export default {
  name: 'Device',
  components: {ShowMsg, DeleteConfirm, Loading, S3FileManager, CustomerSelectDialog},
  data: () => ({
    isReadOnly: false,
    isLoading: false,
    valid: true,
    viewStyle: {},
    startDateMenu: false,
    endDateMenu: false,
    addNewData: 0, //0-新增 1-修改
    datasets: {
      caseId: '',
      id: '',
      serialNumber: '',
      type: '',
      brand: '',
      version: '',
      customer: '',
      contactPerson: '',
      phoneNumber: '',
      emailAddress: '',
      clientAssetNumber: '',
      deviceLocation: '',
      deviceDescription: '',
      sales: [],
      groupName: '',
      projectId: '',
      projectName: '',
      itemName: '',
      itemCode: '',
      sapInvoiceNumber: '',
      deviceCurrency: 'HKD',
      deviceAmount: 1,
      startDateString: '',
      endDateString: '',
      startDate: '',
      endDate: '',
      contractDocuments: [],
      attachmentFiles: [],
      maintenance: [],
      status: 'Active',
      creatorId: '',
      creatorName: '',
      createTimeString: '',
      editorId: '',
      editorName: '',
      updateTimeString: ''
    },
    // Working arrays for tables
    maintenanceRecords: [],
    
    // Dropdown lists
    typeList: [
      { text: i18n.t('__rental'), value: 'Rent' },
      { text: i18n.t('__sold'), value: 'Sold' }
    ],
    currencyList: ['HKD', 'USD', 'CNY', 'TWD'],
    customerList: [],
    groupList: [],
    salesList: [],
    maintenanceList: [],
    
    // Validation rules
    amountRules: [
      v => !!v || i18n.t('__enter') + i18n.t('__deviceAmount'),
      v => (v === '' || v === null || /^\d+(\.\d{1,2})?$/.test(v)) || '最多支援小數點後兩位'
    ],
    
    // UI states
    showAddMaintenanceDialog: false,
    newMaintenanceSerialNumber: '',
    language: '',
    customerDataList: [],  // Full customer objects for auto-fill
    isLoadingFromAPI: false,  // Flag to skip auto-fill during initial data load
    // New Customer Dialog
    showNewCustomerDialog: false,
    newCustomerData: {
      name: '',
      abbreviation: '',
      contactPerson: '',
      phoneNumber: '',
      address: '',
      emailAddress: ''
    },
    // Employee Selection Dialog
    showEmployeeDialog: false,
    employeeDialogMode: '', // 'sales'
    employeeDialogMultiple: true,
    employeeList: [],
    employeeSearchKeyword: '',
    employeeDialogSelected: [],
    // preallocatedId replaced by datasets.caseId
  }),
  mounted() {
    this.language = i18n.locale
    this.addNewData = (this.$route.query.id == -1) ? 0 : 1
    this.initializeLists()
    this.checkMode()
    this.getMaintenanceList()
  },
  computed: {
    canEdit() {
      try {
        const info = getEmployeeInfo()
        if (info && info.function) {
          const perms = JSON.parse(info.function)
          const p = perms.find(e => e.key === 'WarrantyAndMaintenance')
          return p ? !!p.edit : false
        }
      } catch (e) {
        console.error('Failed to parse permissions:', e)
      }
      return false
    },
    filteredEmployeeList() {
      let list = this.employeeList

      // 如果是業務模式，先篩選具備 Sales 角色的人員
      if (this.employeeDialogMode === 'sales') {
        list = list.filter(emp => {
          const roleStr = emp.role || emp.roles || ''
          const roles = roleStr.split(',').map(r => r.trim())
          return roles.includes('Sales')
        })
      }

      if (!this.employeeSearchKeyword) return list
      var kw = this.employeeSearchKeyword.toLowerCase()
      return list.filter(function(emp) {
        return (emp.name && emp.name.toLowerCase().includes(kw)) ||
               (emp.employeeId && emp.employeeId.toLowerCase().includes(kw)) ||
               (emp.title && emp.title.toLowerCase().includes(kw)) ||
               (emp.account && emp.account.toLowerCase().includes(kw)) ||
               (emp.phone && emp.phone.toLowerCase().includes(kw))
      })
    },
    salesDisplay() {
      var val = this.datasets.sales
      if (Array.isArray(val)) return val.join('; ')
      return val || ''
    }
  },
  watch: {
    'datasets.customer': function(newVal) {
      if (this.isLoadingFromAPI) return
      if (!newVal) return
      var matched = this.customerDataList.find(function(c) { return c.name === newVal })
      if (matched) {
        this.datasets.contactPerson = matched.contactPerson || ''
        this.datasets.phoneNumber   = matched.phoneNumber   || ''
        this.datasets.emailAddress  = matched.emailAddress  || ''
      }
    }
  },
  created() {
    this.calculateWindows()
    this.$root.$on('windowInnerHeight', () => {
      this.calculateWindows()
    })
    this.$root.$on('language', (value) => {
      this.language = value
      this.typeList = [
        { text: i18n.t('__rental'), value: 'Rent' },
        { text: i18n.t('__sold'), value: 'Sold' }
      ]
    })
  },
  methods: {
    calculateWindows() {
      this.viewStyle = {height: window.innerHeight - 199 + 'px'}
    },
    redirectPath(path) {
      this.$router.push({ path: path, query: { page: this.$route.query.page, tab: 1 } })
    },
    onSaveSuccess() {
      this.redirectPath('/WarrantyAndMaintenance')
    },
    formatAmount() {
      if (this.datasets.deviceAmount !== null && this.datasets.deviceAmount !== undefined && this.datasets.deviceAmount !== '') {
        this.datasets.deviceAmount = parseFloat(this.datasets.deviceAmount).toFixed(2)
      }
    },
    initializeLists() {
      var self = this
      this.$http.get('/GetCustomerList').then(response => {
        const data = response.data.Data || response.data.data || response.data || []
        if (Array.isArray(data)) {
          self.customerDataList = data  // Store full objects for auto-fill
          self.customerList = data.map(item => item.name)
        }
      })
      // Fetch Groups from Organization list
      this.$http.get('/GetOrganizationList', { params: { currentPage: 1, pageSize: 10 } }).then(response => {
        const data = response.data.Data || response.data.data || response.data || []
        if (Array.isArray(data)) {
          self.groupList = data.map(item => item.groupName).filter(Boolean)
        }
      })
      this.$http.get('/EmployeeList', { params: { currentPage: 1, pageSize: 9999, orderBy: 'name', isNamePriority: true, direction: 'asc' } }).then(response => {
        var data = response.data.Data || response.data.data || response.data || []
        if (Array.isArray(data)) {
          self.employeeList = data
        }
      })
    },
    handleDateSelect(type, val) {
      if (!val) return
      if (type === 'start') {
        this.startDateMenu = false
        if (this.datasets.endDate && val > this.datasets.endDate) {
          this.$refs.ShowMsg.open(0, this.$t('__systemHint'), this.$t('__startDateGreater'))
          return
        }
        this.datasets.startDate = val
        this.datasets.startDateString = val.replace(/-/g, '/')
      }
      if (type === 'end') {
        this.endDateMenu = false
        if (this.datasets.startDate && val < this.datasets.startDate) {
          this.$refs.ShowMsg.open(0, this.$t('__systemHint'), this.$t('__endDateLess'))
          return
        }
        this.datasets.endDate = val
        this.datasets.endDateString = val.replace(/-/g, '/')
      }
    },
    getMaintenanceList(){
      var self = this
      var request = {
        method: 'GET',
        url: '/GetMaintenanceList',
        params: {
          'orderBy': self.orderBy,
          'direction': self.direction,
          'pageSize': 99999,
          'currentPage': 1 ,
          'limit': 9999,
          'keyword': null,
          'customer': null,
          'status': null,
        },
      }
      this.$http(request).then(function(response) {
        self.maintenanceList = response.data.Data || []
      }).catch(()=>{
        alert(this.$t('__systemError', { code: 'Dev-7971' }))
      }).finally(()=>{
      })
    },
    checkMode() {
      if (!this.canEdit) {
        this.isReadOnly = true
      }
      if (this.$route.query.id && this.$route.query.id != -1) {
        this.getDataset(this.$route.query.id)
      } else if (this.$route.query.serialNumber) {
        this.getDataset(null, this.$route.query.serialNumber)
      } else {
        // Fetch pre-allocated ID for new record
        var self = this
        this.$http.get('/Device/PreallocateDeviceId').then(response => {
           const newId = response.data.Data || response.data.data || response.data || ''
           if (newId) {
             self.datasets.caseId = newId
             self.datasets.serialNumber = newId
           }
        }).catch(err => {
           console.error('Failed to pre-allocate Device ID:', err)
        })

        // Defaults for new
        const start = new Date().toISOString().substr(0, 10)
        const end = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
          .toISOString().substr(0, 10)
        this.datasets.startDate = start
        this.datasets.endDate = end
        this.datasets.startDateString = start.replace(/-/g, '/')
        this.datasets.endDateString = end.replace(/-/g, '/')
      }
    },
    deepParse(val) {
      if (val === null || val === undefined) return []
      if (typeof val === 'string') {
        if (!val.trim().startsWith('{') && !val.trim().startsWith('[')) return val
        try {
          const parsed = JSON.parse(val)
          return this.deepParse(parsed)
        } catch (e) {
          return val
        }
      }
      if (Array.isArray(val)) {
        let result = []
        val.forEach(item => {
          const parsed = this.deepParse(item)
          if (Array.isArray(parsed)) {
            result = result.concat(parsed)
          } else {
            result.push(parsed)
          }
        })
        return result
      }
      return val
    },
    getDataset(id, serialNumber) {
      this.isLoading = true
      this.isLoadingFromAPI = true  // Prevent watch from overwriting contact fields
      var self = this
      var url = id ? '/GetDevice' : '/GetDeviceBySerialNumber'
      var params = id ? { id: id, lang: this.language || 'en-US' } : { serialNumber: serialNumber, lang: this.language || 'en-US' }
      var request = {
        method: 'GET',
        url: url, 
        params: params,
      }
      this.$http(request).then(function(response) {
        var res = response.data
        if (res.State == '100' || res.State == '101' || !res.State) {
          var data = res.Data || res.data || res
          if (data) {
            self.datasets = data
            // Deep parse nested strings into working arrays
            self.contractDocuments = self.deepParse(data.contractDocuments)
            if (!Array.isArray(self.contractDocuments)) self.contractDocuments = []

            self.datasets.attachmentFiles = self.deepParse(data.attachmentFiles)
            if (!Array.isArray(self.datasets.attachmentFiles)) self.datasets.attachmentFiles = []
            
            self.maintenanceRecords = self.deepParse(data.maintenance)
            if (!Array.isArray(self.maintenanceRecords)) self.maintenanceRecords = []

            // Format amount to 2 decimal places
            if (self.datasets.deviceAmount !== null && self.datasets.deviceAmount !== undefined) {
              self.datasets.deviceAmount = parseFloat(self.datasets.deviceAmount).toFixed(2)
            }
            
            // 給 picker（YYYY-MM-DD）
            self.datasets.startDate = data.startDateString ? data.startDateString.replace(/\//g, '-') : ''
            self.datasets.endDate = data.endDateString ? data.endDateString.replace(/\//g, '-') : ''
            // 給畫面（YYYY/MM/DD）
            self.datasets.startDateString = data.startDateString ? data.startDateString.substr(0, 10) : ''
            self.datasets.endDateString = data.endDateString ? data.endDateString.substr(0, 10) : ''
            
            // Ensure sales is an array
            if (!Array.isArray(self.datasets.sales)) {
              self.datasets.sales = self.datasets.sales ? [self.datasets.sales] : []
            }
          }
        } else {
          self.$refs.ShowMsg.open(0, this.$t('__queryFailed'), res.Message || this.$t('__getDataError'))
        }
      }).catch((err) => {
        const errorMsg = err.response?.data?.Message || err.response?.data?.ErrorMessage || self.$t('__getDataError')
        self.$refs.ShowMsg.open(0, self.$t('__error'), errorMsg, true, true)
      }).finally(() => {
        self.isLoading = false
        self.$nextTick(() => { self.isLoadingFromAPI = false })  // Reset after Vue finishes rendering
      })
    },
    onSaveSuccess() {
      if (this.$route.path !== '/WarrantyAndMaintenance') {
        this.redirectPath('/WarrantyAndMaintenance')
      }
    },

    // Employee Selection Dialog Methods
    openEmployeeDialog(mode) {
      this.employeeDialogMode = mode
      this.employeeDialogMultiple = true
      this.employeeSearchKeyword = ''
      this.employeeDialogSelected = []
      
      if (mode === 'sales') {
        if (Array.isArray(this.datasets.sales)) {
          this.employeeDialogSelected = [...this.datasets.sales]
        }
      }
      this.showEmployeeDialog = true
    },
    isEmployeeSelected(empName) {
      return this.employeeDialogSelected.includes(empName)
    },
    toggleEmployee(empName) {
      if (this.employeeDialogMultiple) {
        var idx = this.employeeDialogSelected.indexOf(empName)
        if (idx >= 0) {
          this.employeeDialogSelected.splice(idx, 1)
        } else {
          this.employeeDialogSelected.push(empName)
        }
      } else {
        // Single select - toggle if same name
        if (this.employeeDialogSelected.includes(empName)) {
           this.employeeDialogSelected = []
        } else {
           this.employeeDialogSelected = [empName]
        }
      }
    },
    removeSelectedEmployee(empName) {
      var idx = this.employeeDialogSelected.indexOf(empName)
      if (idx >= 0) {
        this.employeeDialogSelected.splice(idx, 1)
      }
    },
    confirmEmployeeSelection() {
      if (this.employeeDialogMode === 'sales') {
        this.datasets.sales = [...this.employeeDialogSelected]
      }
      this.showEmployeeDialog = false
    },

    addMaintenance() {
      if (!this.newMaintenanceSerialNumber || this.maintenanceRecords.length >= 1) return
      this.maintenanceRecords.push({
        serialNumber: this.newMaintenanceSerialNumber
      })
      this.newMaintenanceSerialNumber = ''
      this.showAddMaintenanceDialog = false
    },
    removeMaintenance(idx) {
      this.maintenanceRecords.splice(idx, 1)
    },
    goToMaintenance(serialNumber) {
      if (!serialNumber) return
      const route = this.$router.resolve({
        path: '/maintenance',
        query: { serialNumber }
      })
      window.open(route.href, '_blank')
    },
    addCustomer() {
      this.newCustomerData = {
        name: '',
        abbreviation: '',
        contactPerson: '',
        phoneNumber: '',
        address: '',
        emailAddress: ''
      }
      this.showNewCustomerDialog = true
      if (this.$refs.newCustomerForm) {
        this.$refs.newCustomerForm.resetValidation()
      }
    },
    saveNewCustomer() {
      if (!this.$refs.newCustomerForm.validate()) return
      
      this.isLoading = true
      var self = this
      var request = {
        method: 'POST',
        url: '/CreateCustomer',
        headers: {
          'Content-Type': 'application/json-patch+json'
        },
        data: this.newCustomerData
      }
      
      this.$http(request).then(function(response) {
        self.showNewCustomerDialog = false
        self.$refs.ShowMsg.open(0, i18n.t('__savedSuccessfully'), i18n.t('__savedSuccessfully'))
        
        // Refresh customer list and auto-select the new one
        self.$http.get('/GetCustomerList').then(response => {
          const data = response.data.Data || response.data.data || response.data || []
          if (Array.isArray(data)) {
            self.customerDataList = data  // Store full objects for auto-fill
            self.customerList = data.map(item => item.name)
            
          self.datasets.customer      = self.newCustomerData.name
          self.datasets.contactPerson = self.newCustomerData.contactPerson || ''
          self.datasets.phoneNumber   = self.newCustomerData.phoneNumber   || ''
          self.datasets.emailAddress  = self.newCustomerData.emailAddress  || ''
          if (self.$refs.customerSelectDialog) {
            self.$refs.customerSelectDialog.loadCustomers(self.newCustomerData.name)
          }
          }
        })
      }).catch((error) => {
        const errorMsg = error.response?.data?.Message || this.$t('__saveFailed')
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      }).finally(() => {
        self.isLoading = false
      })
    },
    openCustomerDialog() {
      if (this.isReadOnly) return
      this.$refs.customerSelectDialog.open(this.datasets.customer)
    },
    onCustomerSelected(customer) {
      this.datasets.customer = customer ? customer.name : ''
      if (customer) {
        if (!this.datasets.contactPerson) this.datasets.contactPerson = customer.contactPerson || ''
        if (!this.datasets.phoneNumber) this.datasets.phoneNumber = customer.phoneNumber || ''
        if (!this.datasets.emailAddress) this.datasets.emailAddress = customer.emailAddress || ''
      }
    },
    updateAttachmentFiles(files) {
      this.datasets.attachmentFiles = files
    },
    saveDataset() {
      if (!this.$refs.form.validate()) return

      // Manual required field check
      if (
        !this.datasets.serialNumber ||
        !this.datasets.type ||
        !this.datasets.brand ||
        !this.datasets.customer ||
        !this.datasets.contactPerson ||
        !this.datasets.phoneNumber ||
        !this.datasets.emailAddress ||
        !this.datasets.clientAssetNumber ||
        !this.datasets.deviceLocation ||
        !this.datasets.deviceDescription ||
        !this.datasets.itemName ||
        !this.datasets.itemCode ||
        !this.datasets.sapInvoiceNumber ||
        !this.datasets.deviceCurrency ||
        !this.datasets.deviceAmount
      ) {
        this.$refs.ShowMsg.open(1)
        return
      }

      this.isLoading = true
      var self = this
      var url = this.datasets.id ? '/UpdateDevice' : '/CreateDevice'
      
      var requestData = Object.assign({}, this.datasets)
      // maintenance records saved as JSON string
      requestData.maintenance = JSON.stringify(this.maintenanceRecords)
      requestData.attachmentFiles = JSON.stringify(this.datasets.attachmentFiles)
      // 將日期字串轉為 C# DateTime 所需的 ISO 格式 "YYYY-MM-DDTHH:mm:ss"
      requestData.startDate = this.datasets.startDateString ? this.datasets.startDateString.replace(/\//g, '-') + 'T00:00:00' : null
      requestData.endDate   = this.datasets.endDateString   ? this.datasets.endDateString.replace(/\//g, '-')   + 'T00:00:00' : null
      
      var request = {
        method: 'POST',
        url: url,
        headers: { 'Content-Type': 'application/json-patch+json' },
        data: requestData
      }
      this.$http(request).then(function(response) {
        if (response.data.State === '9884') {
          self.$refs.ShowMsg.open(0, self.$t('__error'), self.$t('__serialNumberExists'))
        } else {
          self.$refs.ShowMsg.open(0, self.$t('__savedSuccessfully'), response.data.Message, true) 
        }
      }).catch((error) => {
        var errorMsg = error.response?.data?.Message || this.$t('__saveFailed')
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      }).finally(() => {
        self.isLoading = false
      })
    },
    onDeleteConfirm(idx){
      this.removeMaintenance(idx)
    },
  }
}
</script>

<style scoped>
#box {
  background-color: white;
  border-radius: 8px;
}
#box .form-row {
  margin-bottom: 2px !important;
}
.text_field >>> .v-input__slot {
  min-height: 36px !important;
}
.pt14 {
  font-size: 14px;
}
.label-style {
  font-weight: 500;
  color: #666;
}
.start {
  color: red;
  margin-right: 4px;
}
.custom-table thead th {
  background-color: #F5F5F5 !important;
  color: #333 !important;
  font-size: 14px !important;
  font-weight: bold !important;
}
.custom-table tbody td {
  font-size: 14px !important;
  color: #555 !important;
  height: 48px !important;
}
.row-even {
  background-color: #FFF8F1 !important;
}
.row-even:hover {
  background-color: #FFF3E6 !important;
}
.border {
  border: 1px solid #EEEEEE;
}

.dialog-btn {
  width: 150px;
  margin: 0px 6px;
  border-radius: 8px;
}

.fixed-footer {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 4 !important; /* Sidebar in Home.vue is z-index 5 */
  background: white !important;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.06) !important;
  padding: 13.5px 0px !important;
}
</style>
